import { Fragment } from 'react';
import ArrLeft from './icons/arr-left-white.svg';
import { SOURCES_TYPES } from '@/common/enums/source-types.enum';
import Tutorial from '@/assets/images/dailyTutorial/samouczek.svg';
import NewHands from '@/common/components/customer/NewHands';
import TasksStatus from './TasksStatus/TaskStatus';
import {
	TopWrapper,
	BackIconWrapper,
	DesktopWrapper,
	ImageWrapper,
	LeftWrapper,
	MobileWrapper,
	NameWrapper,
	Wrapper,
} from './Header.styles';

type HeaderProps = Partial<{
	name: string;
	backTo: string;
	forWhat: string;
	source: string;
	refresh: boolean;
	refreshFunction: () => void;
	muteVoice: boolean;
	setMuteVoice: (value: boolean) => void;
	showVoiceMute: boolean;
	centerDesktop: boolean;
	userVoice: string;
	tasksCurrent: number;
	tasksTotal: number;
	onTasksClick: () => void;
	onBack: () => void;
	onTutorialClick: () => void;
}>;

const Header = ({
	name,
	forWhat,
	source,
	centerDesktop,
	userVoice,
	tasksCurrent,
	tasksTotal,
	onTasksClick,
	onBack,
	onTutorialClick,
}: HeaderProps) => {
	const LayoutsWrapper = centerDesktop ? MobileWrapper : Fragment;

	return (
		<TopWrapper>
			<Wrapper>
				<LeftWrapper>
					<BackIconWrapper onClick={onBack}>
						<img src={ArrLeft} />
					</BackIconWrapper>
					<LayoutsWrapper>
						<NameWrapper>{name}</NameWrapper>
					</LayoutsWrapper>
				</LeftWrapper>
				{centerDesktop && (
					<DesktopWrapper>
						<NameWrapper>{name}</NameWrapper>
					</DesktopWrapper>
				)}
				<div style={{ display: 'flex', gap: '15px', marginRight: '10px' }}>
					<NewHands
						type={source || SOURCES_TYPES.DAILY_V2}
						forWhat={forWhat}
						userVoice={userVoice}
					/>
					{onTutorialClick && (
						<ImageWrapper
							onClick={() => {
								onTutorialClick();
							}}
							style={{ width: '20px', borderRadius: '0' }}
						>
							<img
								src={Tutorial}
								style={{
									height: '20px',
								}}
							/>
						</ImageWrapper>
					)}
				</div>
			</Wrapper>

			<TasksStatus
				total={tasksTotal ?? 0}
				current={tasksCurrent ?? 0}
				onClick={onTasksClick || (() => {})}
			/>
		</TopWrapper>
	);
};

export default Header;
